// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueProgressBar from "vue-progressbar";
import Meta from "vue-meta";
import VueAnalytics from "vue-analytics";
// ここまで Vue 関連のインポート

import "babel-polyfill";
import "whatwg-fetch";
import moment from "moment";
import jwt from "jsonwebtoken";

Vue.config.productionTip = false;

// router.beforeEach と .afterEach で動かす。
Vue.use(VueProgressBar, {
  color: "rgb(143, 255, 199)",
  failedColor: "red",
  height: "2px"
});

Vue.use(Meta);

Vue.use(VueAnalytics, {
  id: "UA-106855600-1",
  router: router,
  debug: {
    sendHitTask: process.env.NODE_ENV === "production"
  }
});

Vue.mixin({
  computed: {
    token() {
      // form の hidden input に埋め込むときなどに使用する。
      return localStorage.token;
    },
    _user() {
      // デバッグ用。
      return this.getUser();
    }
  },
  methods: {
    authedFetch(url, init) {
      if (init === undefined) {
        init = {};
      }
      const headers = { "Content-Type": "application/json" };
      if (localStorage.token) {
        headers.authorization = `Bearer ${localStorage.token}`;
      }
      init.headers = headers;
      return fetch(url, init);
    },
    sitterIdToThumbnailUrl(sitterId) {
      return `${process.env.BACK_ORIGIN}/sitters/thumbnails/id/${sitterId}.jpg`;
    },
    formatDate(momentArg, momentFormat) {
      if (momentArg === "") {
        return "";
      }
      // これ毎回呼ぶのは無駄なだけだと思う。面倒なのでここにおいてるだけ。
      moment.updateLocale("ja", {
        weekdays: [
          "日曜日",
          "月曜日",
          "火曜日",
          "水曜日",
          "木曜日",
          "金曜日",
          "土曜日"
        ],
        weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
      });
      return moment(momentArg).format(momentFormat);
    },
    getUser() {
      // これはフロント側に存在するので、
      // この user の有無によるログインの判断において、セキュリティ的な安全性は何もない。
      // セキュリティ的な部分は全面的にバックエンドでチェックする。
      if (localStorage.token) {
        // ここで jwt.verify は使えない
        // （使うためには secret をここに置かねばならず、それはセキュリティ的に意味不明。）
        const decoded = jwt.decode(localStorage.token);
        if (decoded !== null && decoded.sitterId !== undefined) {
          const expireDate = new Date(decoded.exp * 1000);
          if (new Date() < expireDate) {
            // ここに到達しない場合は最後の return null になる。
            return {
              type: "sitter",
              id: decoded.sitterId,
              nickname: decoded.sitterNickname,
              status: decoded.sitterStatus
            };
          }
        } else if (decoded !== null && decoded.memberId !== undefined) {
          const expireDate = new Date(decoded.exp * 1000);
          if (new Date() < expireDate) {
            // ここに到達しない場合は最後の return null になる。
            return {
              type: "member",
              id: decoded.memberId,
              nickname: decoded.memberNickname,
              status: decoded.memberStatus
            };
          }
        }
      }
      return null;
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});

/*
  TODO:
  ・全体的に margin-bottom で調整しているが、基本としては margin-top で調整するようにしたい。
  ・PriceMain のトップ画像がストライプと子供が一体化しているせいでどうしようもなくなっている。
  ・モバイルファーストとデスクトップファーストでCSSを書いている部分が混在している
  ・ padding-right, padding-left calc(50% - 600px) は共通クラスとしたい。
     @media (min-witdh: 1220px) みたいにして。
  ・全体的にちょっと字が小さい。
  ・メールアドレスまたはパスワードを忘れたページがまだ
  ・サポーターリクルートページ、いくらなんでも「応募する」ボタンがくどくないか？
  ・vue と fontawesome の相性が悪い？
  ・住所の自動選択がまだ
  ・MEMBER_CODE の設定、要するに autoincrement を手動でやってるわけで、複数の申請が同時に来たら終わる。
  ・現在アカウントがある場合に新規メールアドレスで登録すると既存のものが消えてしまうがそれでいいのか？
  ・md5(uniqid) としているのはなぜか。uniqid を直接使ってはいけないのか？
  ・確認画面とか送信されました画面が無駄に感じる。 modal と flash message でなんとかしたい。
  ・レビューはサポーターidユニークにしたほうが良いかと思う
  ・seoのためのリダイレクトとサイトマップ
  ・テーブルの INSERT と UPDATE のトリガー、変更者の記録も。
    今の仕様でタイムゾーンがずれてないかどうかが不明なので確認したい。
  ・どうにかして画像を jpeg に変換したい
  ・404をどうするか
  ・過去が予約できてしまうので修正する（しかし修正するとあまりにもデバッグしにくくなる）。
  ・会社用のスマートフォン？
  ・リクエストの見積もりステータスの遷移が謎、というかチェックされていない。
  ・***Sent 系は一つにまとめたほうが良くないか？
  ・全体的に 24:00 に対応させる。よくに予約作成画面。
  ・ここに書いてあることや、他の部分も issue に移動させる。
  ・事前面談でも子供やオプションが必要なのを修正
*/



// WEBPACK FOOTER //
// ./src/main.js